import Overlayable from '../../mixins/overlayable'
import Toggleable from '../../mixins/toggleable'
import { debounce } from '../../utils/helpers'


export default {
  name: 'navigation-drawer',

  mixins: [Toggleable, Overlayable],

  props: {
    closeOnRouteChange: { type: Boolean, default: true },
    persistent: { type: Boolean },
    underAppBar: { type: Boolean },
    right: { type: Boolean },
    fullWidth: { type: Boolean },
  },

  data () {
    return {
      isActive: this.value,
      debounceToggleOverlay: debounce(this.toggleOverlay, 50), // debounce this, we've had endless issues with animation-end timings etc
    }
  },

  computed: {
    classes () {
      return {
        'navigation-drawer': true,
        'navigation-drawer--close': !this.isActive,
        'navigation-drawer--under-app-bar': this.underAppBar,
        'navigation-drawer--right': this.right,
        'navigation-drawer--full-width': this.fullWidth,
      }
    },

    showOverlay () {
      return !this.persistent && this.isActive
    }
  },

  mounted() {
    if(this.isActive) {
      document.body.classList.add('nav--open')
      if(this.persistent) document.body.classList.add('nav--open-persistent')
    }
  },

  watch: {

    value: {
      handler(val) {
        this.isActive = !!val
        document.body.classList.toggle('nav--open', this.isActive)
        if(this.isActive && this.persistent) document.body.classList.add('nav--open-persistent')
        if(!this.isActive && this.persistent) document.body.classList.remove('nav--open-persistent')
      },
    },

    persistent: {
      handler(val) {
        if(this.persistent && this.isActive) document.body.classList.add('nav--open-persistent')
        if(!this.persistent && this.isActive) document.body.classList.remove('nav--open-persistent')
      },
    },

    showOverlay (val) {
      this.debounceToggleOverlay()
    },

    '$route'() {
      if (this.closeOnRouteChange) {
        this.isActive = !this.closeConditional()
      }
    },
  },

  methods: {    
    closeConditional () {
      return !this.persistent || !this.isActive
    },

    toggleOverlay() {
      if(this.showOverlay) this.genOverlay()
      else this.removeOverlay()
    }
  },

  render (h) {
    const data = {
      'class': this.classes,
      directives: [{
        name: 'click-outside',
        value: this.closeConditional
      }],
    }

    return h('aside', data, [this.$slots.default])
  },

  beforeDestroy() {
    this.removeOverlay();
    document.body.classList.remove('nav--open', 'nav--open-persistent')
  },
}
